import { Tag, Space, App } from 'antd';
import { MaterialIcon } from '@/components/MaterialIcon';
import { View } from '@/types';

interface DrawerViewTitleProps {
  view: View | null | undefined;
}

export function DrawerViewTitle({ view }: DrawerViewTitleProps) {
  const { message } = App.useApp();

  const handleCopyToken = async (token: string) => {
    try {
      await navigator.clipboard.writeText(token);
      message.success('Token copied to clipboard');
    } catch {
      message.error('Failed to copy token');
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
        <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.45)', fontWeight: 400, textTransform: 'uppercase', letterSpacing: 0.3 }}>
          View
        </span>
        <span style={{ fontSize: 17, fontWeight: 700, color: '#fff' }}>
          {view?.name || ''}
        </span>
      </div>
      <Space size="small" style={{ marginTop: 6 }}>
        {view?.token && (
          <Tag
            variant="outlined"
            style={{
              cursor: 'pointer',
              color: 'rgba(255,255,255,0.65)',
              borderColor: 'rgba(255,255,255,0.15)',
              background: 'transparent',
              fontWeight: 400,
            }}
            title="Click to copy token"
            onClick={() => handleCopyToken(view.token)}
          >
            <MaterialIcon name="key" size={13} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            {view.token}
          </Tag>
        )}
        <Tag
          variant="outlined"
          style={{
            color: 'rgba(255,255,255,0.65)',
            borderColor: 'rgba(255,255,255,0.15)',
            background: 'transparent',
            fontWeight: 400,
          }}
        >
          <MaterialIcon name="phone_android" size={13} style={{ marginRight: 4, verticalAlign: 'middle' }} />
          {view?.androidStatus?.device?.model || 'No device'}
        </Tag>
      </Space>
    </div>
  );
}
